<template>
  <div class="admin-userlist">
    <admin-template
      :endpointUrl="endpointUrl"
      :title="title"
      :visibleBulkUpdate="true"
      :tableSort="{prop: 'username', order: 'ascending'}"
    >
      <template slot="table-columns">
        <el-table-column type="selection" width="55" :selectable="selectableRow"></el-table-column>
        <el-table-column prop="tenant_name" label="テナント名" width="130" sortable>
          <template slot-scope="scope">{{ scope.row.tenant_name }}</template>
        </el-table-column>
        <el-table-column prop="username" label="ユーザ名" width="150" sortable>
          <template slot-scope="scope">{{ scope.row.username}}</template>
        </el-table-column>
        <el-table-column prop="nickname" label="ニックネーム" width="150" sortable>
          <template slot-scope="scope">{{ scope.row.nickname}}</template>
        </el-table-column>
        <el-table-column prop="role_name" label="ロール名" width="130" sortable>
          <template slot-scope="scope">{{ scope.row.role_name}}</template>
        </el-table-column>
        <el-table-column prop="use_ai" label="AI利用" width="90" sortable>
        <template slot-scope="scope">
          <i v-if="scope.row.use_ai" class="el-icon-check" style="color: green;"></i>
          <span v-else></span>
        </template>
        </el-table-column>        
        <el-table-column prop="role_name" label="アカウント有効期限" width="160" sortable>
          <template slot-scope="scope">{{ scope.row.end_date}}</template>
        </el-table-column>
        <el-table-column prop="lastLogin" label="最終ログイン日時" width="180" sortable>
          <template slot-scope="scope">{{ scope.row.last_login | sqlFormatDate }}</template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              icon="el-icon-edit"
              size="small"
              @click="onClickEditButton(scope.row.uuid)"
            >編集</el-button>
            <el-button size="small" @click="onClickPasswordResetButton(scope.row.uuid)">パスワード変更</el-button>
          </template>
        </el-table-column>
      </template>
    </admin-template>

    <admin-dialog
      :endpointUrl="endpointUrl"
      :endpointBulkDeleteUrl="endpointBulkUrl"
      :title="title"
      :form="form"
      :selection="selection"
    >
      <template slot="dialogFormItem" slot-scope="{isEdit}" class="hello">
        <el-form-item label="テナント名" prop="tenant">
          <el-select
            v-model="form.data.tenant"
            filterable
            placeholder="テナントを選択"
            :disabled="isEdit"
            class="dialog-select"
            :autofocus="true"
          >
            <el-option
              v-for="t in $store.getters.tenants.data"
              :key="t.name"
              :label="t.name"
              :value="t.uuid"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="ユーザ名" prop="username">
          <el-input v-model="form.data.username" auto-complete="off" :disabled="isEdit"></el-input>
        </el-form-item>
        <el-form-item v-if="!isEdit" label="パスワード" prop="password">
          <el-input v-model="form.data.password" type="password" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item v-if="!isEdit" label="パスワード(確認用)" prop="verify_password">
          <el-input v-model="form.data.verify_password" type="password" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="ニックネーム" prop="nickname">
          <el-input
            v-model="form.data.nickname"
            auto-complete="off"
            :clearable="true"
            @focus="inputDefaultNickname"
          ></el-input>
        </el-form-item>
        <el-form-item label="ロール" prop="role_name">
          <el-select
            v-model="form.data.role_name"
            :disabled="form.data.username === 'admin' || form.data.username === $store.getters.loginStatus.username"
          >
            <el-option
              v-for="item in roles.names"
              :key="item.name"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="アカウントレベル" prop="level">
          <el-select v-model="form.data.level">
            <el-option
              v-for="item in level_options"
              :key="item.label"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="AI利用">
          <el-switch v-model="form.data.use_ai"></el-switch>
        </el-form-item>

        <el-form-item v-if="form.data.use_ai" prop="ai_level">
          <el-select v-model="form.data.ai_level" placeholder="AI利用レベルを選択">
            <el-option
              v-for="item in ai_level_options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="アカウント有効期間" prop="valid_period">
          <el-date-picker
            v-model="form.data.valid_period"
            type="daterange"
            align="right"
            start-placeholder="開始日"
            end-placeholder="終了日"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
      </template>
    </admin-dialog>

    <el-dialog
      :title="passwordDialog.title"
      :visible.sync="passwordDialog.visible"
      :close-on-click-modal="false"
    >
      <el-form
        :ref="form.ref"
        :model="form.data"
        :label-width="form.labelWidth"
        :rules="form.rules.create"
        autocomplete="off"
        @submit.prevent.native="handlePasswordReset"
      >
        <el-form-item label="パスワード" prop="password">
          <el-input v-model="form.data.password" type="password" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="パスワード(確認用)" prop="verify_password">
          <el-input v-model="form.data.verify_password" type="password" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <el-alert
        v-if="passwordDialog.isAlert"
        :title="passwordDialog.errorMessage"
        type="error"
        show-icon
        :closable="false"
      ></el-alert>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handlePasswordReset" :loading="passwordDialog.loading">OK</el-button>
        <el-button @click="passwordDialog.visible=false">キャンセル</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="ユーザ一括更新"
      :visible.sync="bulkUpdateDialog.visible"
      :close-on-click-modal="false"
    >
      <el-form
        :ref="bulkUpdateDialog.form.ref"
        :model="bulkUpdateDialog.form.data"
        :label-width="bulkUpdateDialog.form.labelWidth"
        :rules="bulkUpdateDialog.form.rules"
        autocomplete="off"
        @submit.prevent.native="handleBulkUpdate"
      >
        <el-form-item label="アカウントレベル" prop="level">
          <el-select v-model="bulkUpdateDialog.form.data.level">
            <el-option
              v-for="item in level_options"
              :key="item.label"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="アカウント有効期間" prop="valid_period">
          <el-date-picker
            v-model="bulkUpdateDialog.form.data.valid_period"
            type="daterange"
            align="right"
            start-placeholder="開始日"
            end-placeholder="終了日"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <el-alert
        v-if="bulkUpdateDialog.isAlert"
        :title="bulkUpdateDialog.errorMessage"
        type="error"
        show-icon
        :closable="false"
      ></el-alert>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleBulkUpdate" :loading="passwordDialog.loading">OK</el-button>
        <el-button @click="bulkUpdateDialog.visible=false">キャンセル</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AdminTemplate from "@/components/admin/Template";
import AdminDialog from "@/components/admin/Dialog";
import { AdminEventBus } from "@/components/admin/EventBus";
import { executeRequest } from "@/components/requests";
import axios from "axios";

export default {
  components: {
    AdminTemplate,
    AdminDialog
  },

  data() {
    var validatePass = (rule, value, callback) => {
      if (value !== this.form.data.password) {
        callback(
          new Error("新パスワードと新パスワード(確認用)が一致していません")
        );
      } else {
        callback();
      }
    };
    var validateAiOption = (rule, value, callback) => {
      if (this.form.data.use_ai && !value) {
        callback(new Error("AI利用レベルを選択してください"));
      } else {
        callback();
      }
    };
    // const level_options = [
    //   {
    //     label: "無料(JC3デモ)",
    //     value: "FREE_JC3"
    //   },
    //   {
    //     label: "無料(NEC貸出)",
    //     value: "FREE_NEC_RENTAL"
    //   },
    //   {
    //     label: "無料(NEC PoC)",
    //     value: "FREE_NEC_POC"
    //   },
    //   {
    //     label: "有料(廉価版)",
    //     value: "LOW_COST_USAGE"
    //   },
    //   {
    //     label: "有料(フル機能)",
    //     value: "EXPENSIVE_USAGE"
    //   }
    // ];

    const level_options = [
      {
        label: "無料(フル機能)",
        value: "FREE_JC3"
      },
      {
        label: "無料(制限版)",
        value: "FREE_NEC_RENTAL"
      },
      {
        label: "有料(廉価版)",
        value: "LOW_COST_USAGE"
      },
      {
        label: "有料(フル機能)",
        value: "EXPENSIVE_USAGE"
      },
      {
        label: "有料(プロ機能)",
        value: "FREE_NEC_POC"
      },
      {
        label: "実証実験",
        value: "TEST_USAGE"
      }      
    ];

    const ai_level_options = [
      {
        label: "1万投稿",
        value: "1"
      },
      {
        label: "5万投稿",
        value: "2"
      },
      {
        label: "10万投稿",
        value: "3"
      }
    ];
    
    const endpointUrl = "/api/accounts/admin/users/";
    const endpointBulkUrl = "/api/accounts/admin/users-bulk/";
    const endpointRoleNamesUrl = "/api/accounts/admin/role-names/";
    const title = "ユーザ管理";
    const initialFormData = {
      uuid: 0,
      tenant: "",
      username: "",
      password: "",
      verify_password: "",
      nickname: "",
      role_name: "一般ユーザ",
      valid_period: [],
      level: "FREE_JC3",
      use_ai: false,
      ai_level: ""
    };

    const commonRules = {
      username: [
        {
          required: true,
          message: "ユーザ名を入力してください",
          trigger: "blur"
        }
      ],
      nickname: [
        {
          required: true,
          message: "ニックネームを入力してください",
          trigger: "blur"
        }
      ],
      role_name: [
        {
          required: true,
          message: "ロールを入力してください",
          trigger: "blur"
        }
      ],
      level: [
        {
          required: true,
          message: "アカウントレベルを入力してください",
          trigger: "blur"
        }
      ],
      ai_level: [
        { validator: validateAiOption, trigger: "blur" }
      ]
    };

    return {
      title,
      endpointUrl,
      endpointBulkUrl,
      endpointRoleNamesUrl,
      level_options,
      ai_level_options,
      initialFormData,
      form: {
        ref: "adminUserForm",
        labelWidth: "150px",
        data: Object.assign({}, initialFormData, {}),
        rules: {
          create: Object.assign(
            {
              tenant: [
                {
                  required: true,
                  message: "テナント名を入力してください",
                  trigger: "blur"
                }
              ],
              password: [
                {
                  required: true,
                  message: "パスワードを入力してください",
                  trigger: "blur"
                }
              ],
              verify_password: [
                {
                  required: true,
                  message: "パスワード(確認用)を入力してください",
                  trigger: "blur"
                },
                { validator: validatePass, trigger: "blur" }
              ]
            },
            commonRules
          ),
          update: commonRules
        }
      },
      selection: [],
      roles: {
        names: []
      },
      tenants: {
        names: [],
        dict: {},
        data: {}
      },
      passwordDialog: {
        isAlert: false,
        errorMessage: "",
        visible: false,
        loading: false,
        title: ""
      },
      bulkUpdateDialog: {
        isAlert: false,
        errorMessage: "",
        visible: false,
        loading: false,
        form: {
          ref: "bulkupdateForm",
          data: { level: "", valid_period: [] },
          labelWidth: "150px",
          rules: {}
        }
      }
    };
  },
  created() {
    AdminEventBus.$on("init-form", () => {
      this.initForm();
    });
    AdminEventBus.$on("click-bulkUpdate", idlist => {
      this.bulkUpdateDialog.form.data = Object.assign(
        {},
        this.bulkUpdateDialog.form.data,
        {
          level: "",
          valid_period: [],
          idlist: idlist
        }
      );
      this.bulkUpdateDialog.visible = true;
    });
  },
  methods: {
    initForm() {
      this.form.data = Object.assign({}, this.initialFormData, {
        tenant: this.$route.query.tid
      });
      this.fetchExtras();
    },
    fetchExtras(next) {
      axios.get(this.endpointRoleNamesUrl).then(response => {
        this.roles.names = response.data;
        if (next !== undefined) {
          next();
        }
      });
    },
    onClickEditButton(uuid) {
      this.fetchExtras(() => {
        axios.get(`${this.endpointUrl}${uuid}/`).then(response => {
          this.form.data = response.data;
          AdminEventBus.$emit("click-edit");
        });
      });
    },
    onClickPasswordResetButton(id) {
      this.passwordDialog = Object.assign({}, this.passwordDialog, {
        isAlert: false,
        errorMessage: "",
        visible: false,
        loading: false,
        title: ""
      });
      let ref = this.$refs[this.form.ref];
      if (ref !== undefined) {
        ref.resetFields();
        this.$nextTick(() => ref.$el[0].focus());
      }
      axios.get(`${this.endpointUrl}${id}/`).then(response => {
        this.form.data = response.data;
        this.passwordDialog.title = `${
          this.form.data.username
        }のパスワード変更`;
        this.passwordDialog.visible = true;
      });
    },
    handlePasswordReset() {
      const request = {
        method: "post",
        url: `${this.endpointUrl}${this.form.data.uuid}/reset-password/`,
        data: {
          id: this.form.data.uuid,
          password: this.form.data.password,
          verify_password: this.form.data.verify_password
        }
      };
      const validator = this.$refs[this.form.ref].validate;
      executeRequest(request, this.passwordDialog, validator)
        .then(reponse => {})
        .catch(error => {
          console.log(error);
        });
    },
    handleBulkUpdate() {
      const request = {
        method: "put",
        url: this.endpointBulkUrl,
        data: this.bulkUpdateDialog.form.data
      };
      const validator = this.$refs[this.bulkUpdateDialog.form.ref].validate;
      executeRequest(request, this.bulkUpdateDialog, validator)
        .then(response => {})
        .catch(error => {
          console.log(error);
        });
    },
    selectableRow(row, index) {
      if (row.username === "admin") {
        return false;
      } else if (row.username === this.$store.getters.loginStatus.username) {
        return false;
      }
      return true;
    },
    inputDefaultNickname() {
      if (this.form.data.nickname.length === 0) {
        // 設定されてない場合は、デフォルトでユーザ名を設定する。
        this.form.data.nickname = this.form.data.username;
      }
    }
  }
};
</script>

<style scoped>
</style>
